// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.line-notify-img-width[data-v-aa884ed4]{\n  width: 50px;\n}\n.device-img-width[data-v-aa884ed4]{\n  width: 45px;\n}\n.logo-img[data-v-aa884ed4] {\n  margin-bottom: 8px;\n  width:45px;\n}\n", ""]);
// Exports
module.exports = exports;
